import type { UpdateContractMemoRequestPayload, UpdateContractMemoResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateContractsQueries } from '../../utils/query-invalidation';
import { queryKeys } from '../../services/query-key/query-keys';

type UpdateContractMemoVariables = UpdateContractMemoRequestPayload & { contractId: string };

export function useUpdateContractMemo(
  options?: UseMutationOptions<UpdateContractMemoResponse, Error, UpdateContractMemoVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ contractId, ...updateContractMemoRequest }) => {
      const api = getPrivateApi();

      return api.updateContractMemo({
        contractId,
        updateContractMemoRequest,
      });
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await Promise.all([
          invalidateContractsQueries(queryClient),
          queryClient.invalidateQueries(queryKeys.contractPage(data.contractId)),
        ]);

        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
